module.exports = __webpack_public_path__ + "img/13.3611df24.png";